import { memo, type ReactNode, useEffect } from 'react';

import { WorkspaceHeaderInformation } from '~/components/v2/components/workspace/workspace-header/WorkspaceHeaderInformation';
import { useWorkspaceRightPanelOpen } from '~/components/v2/store/features/workspace/useWorkspaceRightPanelOpen';
import { useWorkspaceRightPanelStore } from '~/components/v2/store/features/workspace/useWorkspaceRightPanelStore';

export type WorkspaceHeaderProps = {
  actions?: ReactNode;
  search?: ReactNode;
};

export const WorkspaceHeader = memo(({ actions, search }: WorkspaceHeaderProps) => {
  const rightPanelOpen = useWorkspaceRightPanelOpen();
  const setRightPanelOpen = useWorkspaceRightPanelStore((state) => state.setOpen);
  const selectedCanvasId = useWorkspaceRightPanelStore((state) => state.selectedCanvasId);
  const draftCanvas = useWorkspaceRightPanelStore((state) => state.draftCanvas);

  useEffect(() => {
    if (!selectedCanvasId && !draftCanvas && rightPanelOpen) {
      setRightPanelOpen(false);
    }
  }, [rightPanelOpen, selectedCanvasId, draftCanvas, setRightPanelOpen]);

  return (
    <header className="flex h-16 shrink-0 items-center justify-center">
      <div className="flex min-w-min flex-1 justify-start">
        <WorkspaceHeaderInformation />
      </div>
      <div className="flex items-center justify-center px-2">
        <div className="w-[600px]">{search}</div>
      </div>
      <div className="flex min-w-min flex-1 justify-end">
        {/* The padding needs to be on the child element otherwise it'll unalign the center div */}
        <div className="flex gap-2 px-4">{actions}</div>
      </div>
    </header>
  );
});

WorkspaceHeader.displayName = 'WorkspaceHeader';
